import {
  VscJson,
  VscCode,
  VscDiff,
  VscDatabase,
  VscShield,
  VscRegex,
  VscLink,
  VscSymbolKey,
  VscWatch,
  VscLock,
  VscFileCode,
  VscPackage,
  VscVerified,
  VscMarkdown,
  VscColorMode,
  VscTerminal,
  VscGlobe,
  VscKey,
  VscTable,
} from 'react-icons/vsc';

export const categories = [
  'All',
  'JSON',
  'API',
  'Security',
  'Database',
  'Encoding',
  'Text',
  'Utilities',
];

export const tools = [
  // Large Featured Cards
  {
    id: 'json-formatter',
    name: 'JSON Formatter',
    description: 'Format, beautify and validate JSON with syntax highlighting',
    icon: VscJson,
    category: 'JSON',
    size: 'large',
    usage: '2.4M',
    accent: '#5B8CFF',
  },
  {
    id: 'api-tester',
    name: 'API Tester',
    description: 'Test REST APIs with custom headers, body and authentication',
    icon: VscGlobe,
    category: 'API',
    size: 'large',
    usage: '1.8M',
    accent: '#22C55E',
  },
  {
    id: 'diff-checker',
    name: 'Diff Checker',
    description: 'Compare text, code or files side-by-side with inline diffs',
    icon: VscDiff,
    category: 'Text',
    size: 'large',
    usage: '1.2M',
    accent: '#EF4444',
  },
  // Medium Cards
  // {
  //   id: 'xml-formatter',
  //   name: 'XML Formatter',
  //   description: 'Pretty-print and validate XML documents',
  //   icon: VscFileCode,
  //   category: 'Text',
  //   size: 'medium',
  //   usage: '890K',
  //   accent: '#F59E0B',
  // },
  // {
  //   id: 'yaml-viewer',
  //   name: 'YAML Viewer',
  //   description: 'Parse and visualize YAML configurations',
  //   icon: VscCode,
  //   category: 'Text',
  //   size: 'medium',
  //   usage: '720K',
  //   accent: '#A855F7',
  // },
  {
    id: 'jwt-decoder',
    name: 'JWT Decoder',
    description: 'Decode and inspect JSON Web Tokens',
    icon: VscShield,
    category: 'Security',
    size: 'large',
    usage: '1.1M',
    accent: '#00D9FF',
  },
  {
    id: 'sql-formatter',
    name: 'SQL Formatter',
    description: 'Beautify and format SQL queries instantly',
    icon: VscDatabase,
    category: 'Database',
    size: 'large',
    usage: '950K',
    accent: '#06B6D4',
  },
  // {
  //   id: 'regex-tester',
  //   name: 'Regex Tester',
  //   description: 'Test and debug regular expressions in real-time',
  //   icon: VscRegex,
  //   category: 'Text',
  //   size: 'medium',
  //   usage: '1.3M',
  //   accent: '#34D399',
  // },
  // Small Cards
  {
    id: 'base64-encoder',
    name: 'Base64 Encoder',
    description: 'Encode and decode Base64 strings',
    icon: VscPackage,
    category: 'Encoding',
    size: 'large',
    usage: '680K',
    accent: '#F472B6',
  },
  // {
  //   id: 'url-encoder',
  //   name: 'URL Encoder',
  //   description: 'Encode and decode URL components',
  //   icon: VscLink,
  //   category: 'Encoding',
  //   size: 'small',
  //   usage: '540K',
  //   accent: '#818CF8',
  // },
  {
    id: 'color-converter',
    name: 'Color Converter',
    description: 'Convert between HEX, RGB, HSL',
    icon: VscColorMode,
    category: 'Utilities',
    size: 'large',
    usage: '420K',
    accent: '#FB923C',
  },
  // {
  //   id: 'json-validator',
  //   name: 'JSON Validator',
  //   description: 'Validate JSON against schemas',
  //   icon: VscVerified,
  //   category: 'JSON',
  //   size: 'small',
  //   usage: '760K',
  //   accent: '#5B8CFF',
  // },
  // {
  //   id: 'json-minifier',
  //   name: 'JSON Minifier',
  //   description: 'Minify JSON to reduce file size',
  //   icon: VscTerminal,
  //   category: 'JSON',
  //   size: 'small',
  //   usage: '510K',
  //   accent: '#64748B',
  // },
  // {
  //   id: 'xml-validator',
  //   name: 'XML Validator',
  //   description: 'Validate XML structure and syntax',
  //   icon: VscFileCode,
  //   category: 'Text',
  //   size: 'small',
  //   usage: '380K',
  //   accent: '#F59E0B',
  // },
  // {
  //   id: 'uuid-generator',
  //   name: 'UUID Generator',
  //   description: 'Generate unique UUIDs v4',
  //   icon: VscSymbolKey,
  //   category: 'Utilities',
  //   size: 'small',
  //   usage: '620K',
  //   accent: '#8B5CF6',
  // },
  {
    id: 'timestamp-converter',
    name: 'Timestamp Converter',
    description: 'Convert Unix timestamps to dates',
    icon: VscWatch,
    category: 'Utilities',
    size: 'large',
    usage: '490K',
    accent: '#14B8A6',
  },
  // {
  //   id: 'hash-generator',
  //   name: 'Hash Generator',
  //   description: 'Generate MD5, SHA-1, SHA-256 hashes',
  //   icon: VscLock,
  //   category: 'Security',
  //   size: 'small',
  //   usage: '570K',
  //   accent: '#EC4899',
  // },
  // {
  //   id: 'markdown-preview',
  //   name: 'Markdown Preview',
  //   description: 'Live preview Markdown rendering',
  //   icon: VscMarkdown,
  //   category: 'Text',
  //   size: 'small',
  //   usage: '440K',
  //   accent: '#10B981',
  // },
  {
    id: 'html-formatter',
    name: 'HTML Formatter',
    description: 'Beautify, minify and validate HTML',
    icon: VscFileCode,
    category: 'Text',
    size: 'large',
    usage: '680K',
    accent: '#F97316',
  },
  {
    id: 'excel-compare',
    name: 'Excel Compare',
    description: 'Compare multi-sheet Excel & CSV files with cell-level diffs',
    icon: VscTable,
    category: 'Text',
    size: 'large',
    usage: '320K',
    accent: '#10B981',
  },
];
